/** Production site URL, no trailing slash. Override at build time with REACT_APP_SITE_URL. */
export function getSiteOrigin() {
  return (process.env.REACT_APP_SITE_URL || 'https://rebirtok.hu').replace(/\/$/, '');
}

export function absoluteUrl(pathname) {
  const origin = getSiteOrigin();
  if (!pathname || pathname === '/') return `${origin}/`;
  const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${origin}${p}`;
}
